import React, { useState } from "react";
import axios from "axios";


const usePosition = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [depthData, setDepthData] = useState([])
    const getPositionData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/inventory_check/api/position', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                setDepthData(data?.depth_response?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postPositionData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/inventory_check/api/position',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchPositionData = (data) => {

        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/inventory_check/api/position',

            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deletePositionData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/inventory_check/api/position',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        PositionData: data,
        PositionDepthData: depthData,
        getPositionData,
        postPositionData,
        patchPositionData,
        deletePositionData,
    }
}
export { usePosition }
